<div ng-transclude="result">
  VAJCO! + {{result.value}}
</div>